// Traduceri în limba română pentru interfața OpenProject Dashboard

export const translations = {
  // Navigare
  nav: {
    dashboard: 'Tablou de bord',
    myActivities: 'Activitățile mele',
    myProjects: 'Proiectele mele',
    search: 'Căutare',
    settings: 'Setări',
    logout: 'Deconectare',
    profile: 'Profil',
  },

  // Autentificare
  auth: {
    title: 'Autentificare OpenProject',
    subtitle: 'Conectați-vă la instanța dvs. OpenProject',
    instanceUrl: 'Adresa instanței OpenProject',
    instanceUrlPlaceholder: 'https://openproject.exemplu.ro',
    username: 'Nume utilizator',
    usernamePlaceholder: 'Introduceți numele de utilizator',
    password: 'Parolă',
    passwordPlaceholder: 'Introduceți parola',
    login: 'Autentificare',
    loggingIn: 'Se autentifică...',
    rememberMe: 'Păstrează-mă autentificat',
    errors: {
      invalidCredentials: 'Credențiale invalide. Verificați numele de utilizator și parola.',
      connectionFailed: 'Conexiune eșuată. Verificați adresa instanței.',
      serverError: 'Eroare de server. Încercați din nou mai târziu.',
      networkError: 'Eroare de rețea. Verificați conexiunea la internet.',
      tokenInvalid: 'Token invalid sau conexiune eșuată. Verifică datele introduse sau contactează administratorul.',
    },
    success: {
      loggedIn: 'Autentificare reușită!',
      loggedOut: 'Ați fost deconectat cu succes.',
    },
  },

  // Dashboard
  dashboard: {
    title: 'Activitățile mele',
    welcome: 'Bine ai venit',
    noActivities: 'Nu aveți activități atribuite.',
    groups: {
      todo: 'De făcut',
      inProgress: 'În lucru',
      completed: 'Finalizate recent',
    },
    filters: {
      project: 'Proiect',
      allProjects: 'Toate proiectele',
      deadline: 'Termen',
      today: 'Astăzi',
      thisWeek: 'Săptămâna aceasta',
      thisMonth: 'Luna aceasta',
      all: 'Toate',
      type: 'Tip',
      allTypes: 'Toate tipurile',
    },
    quickActions: {
      changeStatus: 'Schimbă status',
      viewDetails: 'Vezi detalii',
      addTime: 'Înregistrează timp',
    },
  },

  // Proiecte
  projects: {
    title: 'Proiectele mele',
    noProjects: 'Nu sunteți membru în niciun proiect.',
    addProject: 'Adaugă proiect',
    editProject: 'Editează proiect',
    deleteProject: 'Șterge proiect',
    projectDetails: 'Detalii proiect',
    tabs: {
      phasesAndTasks: 'Faze & activități & repere',
      milestones: 'Repere',
      members: 'Membri',
      details: 'Detalii proiect',
    },
    // Terminologie unitară pentru taburile Dosarului Investiției (etichete scurte).
    // Ordinea reflectă lanțul dosarului: Achiziție → Contract → Livrabile → Implementare.
    dossierTabs: {
      details: 'Detalii',
      achizitii: 'Achiziții',
      contracte: 'Contracte',
      livrabile: 'Livrabile',
      implementare: 'Implementare',
      gantt: 'Cronologie (Gantt)',
      files: 'Fișiere',
      members: 'Membri',
    },
    header: {
      responsible: 'Responsabil',
      contractValue: 'Valoare contract',
      deadline: 'Termen-limită',
      noResponsible: 'Neatribuit',
    },
    nextStep: {
      title: 'Următorul pas',
      allGood: 'Dosarul este echilibrat. Continuă cu pașii următori pe măsură ce apar termene.',
      startProcurement: 'Începe dosarul: adaugă prima achiziție.',
      needContract: 'Atribuie un contract pentru achizițiile existente.',
      needDeliverable: 'Adaugă cel puțin un livrabil pentru contractele existente.',
      goToTab: 'Mergi la pas',
    },
    fields: {
      name: 'Nume proiect',
      identifier: 'Identificator',
      description: 'Descriere',
      status: 'Status',
      startDate: 'Data de început',
      endDate: 'Data de sfârșit',
      public: 'Proiect public',
      parent: 'Proiect părinte',
      createdAt: 'Creat la',
      updatedAt: 'Actualizat la',
    },
    actions: {
      addPhase: 'Adaugă fază',
      addTask: 'Adaugă activitate',
      addMilestone: 'Adaugă reper',
      addMember: 'Adaugă membru',
    },
    members: {
      name: 'Nume',
      email: 'Email',
      role: 'Rol',
      addedAt: 'Adăugat la',
    },
    customFields: 'Câmpuri suplimentare',
    generalInfo: 'Informații generale',
  },

  // Work Packages
  workPackages: {
    title: 'Activități',
    noWorkPackages: 'Nu există activități în acest proiect.',
    addWorkPackage: 'Adaugă activitate',
    editWorkPackage: 'Editează activitate',
    deleteWorkPackage: 'Șterge activitate',
    confirmDelete: 'Sigur doriți să ștergeți această activitate?',
    types: {
      task: 'Activitate',
      phase: 'Fază',
      milestone: 'Reper',
      bug: 'Defect',
      feature: 'Funcționalitate',
      epic: 'Epic',
      userStory: 'User Story',
    },
    tabs: {
      essential: 'Detalii',
      planning: 'Planificare & structură',
      content: 'Documente',
      tracking: 'Timpi de lucru',
      advanced: 'Avansat',
    },
    fields: {
      // Esențial
      subject: 'Subiect',
      type: 'Tip',
      status: 'Status',
      priority: 'Prioritate',
      project: 'Proiect',
      assignee: 'Executant',
      responsible: 'Responsabil',
      dueDate: 'Termen limită',
      parent: 'Părinte',

      // Planificare
      startDate: 'Data de început',
      estimatedTime: 'Estimare timp',
      remainingTime: 'Timp rămas',
      spentTime: 'Timp petrecut',
      version: 'Versiune',
      category: 'Categorie',

      // Conținut
      description: 'Descriere',
      attachments: 'Atașamente',

      // Relații
      relations: 'Relații',
      children: 'Sub-activități',

      // Metadata
      author: 'Autor',
      createdAt: 'Creat la',
      updatedAt: 'Actualizat la',
      lockVersion: 'Versiune blocare',
    },
    relations: {
      title: 'Relații',
      add: 'Adaugă relație',
      types: {
        relates: 'Se referă la',
        duplicates: 'Duplică',
        duplicated: 'Duplicat de',
        blocks: 'Blochează',
        blocked: 'Blocat de',
        precedes: 'Precede',
        follows: 'Urmează',
        includes: 'Include',
        partOf: 'Parte din',
        requires: 'Necesită',
        required: 'Necesar pentru',
      },
    },
    hierarchy: {
      phases: 'Faze',
      tasks: 'Activități',
      milestones: 'Repere',
      noChildren: 'Nu există sub-activități.',
    },
  },

  // Statusuri (mapare pentru traducere)
  statuses: {
    new: 'Nou',
    'in progress': 'În lucru',
    'in specification': 'În specificare',
    specified: 'Specificat',
    confirmed: 'Confirmat',
    'to be scheduled': 'De programat',
    scheduled: 'Programat',
    'in development': 'În dezvoltare',
    developed: 'Dezvoltat',
    'in testing': 'În testare',
    tested: 'Testat',
    'test failed': 'Test eșuat',
    closed: 'Închis',
    'on hold': 'În așteptare',
    rejected: 'Respins',
  },

  // Priorități
  priorities: {
    immediate: 'Imediat',
    high: 'Înalt',
    normal: 'Normal',
    low: 'Scăzut',
  },

  // Atașamente
  attachments: {
    title: 'Atașamente',
    upload: 'Încarcă fișier',
    uploadHint: 'Trageți fișierele aici sau apăsați pentru a selecta',
    uploading: 'Se încarcă...',
    delete: 'Șterge',
    download: 'Descarcă',
    noAttachments: 'Nu există atașamente.',
    fileName: 'Nume fișier',
    fileSize: 'Mărime',
    uploadedAt: 'Data încărcării',
    uploadedBy: 'Încărcat de',
    errors: {
      uploadFailed: 'Încărcarea fișierului a eșuat.',
      deleteFailed: 'Ștergerea fișierului a eșuat.',
      fileTooLarge: 'Fișierul este prea mare.',
      invalidType: 'Tip de fișier invalid.',
    },
  },

  // Înregistrare timp
  timeTracking: {
    title: 'Timp înregistrat',
    add: 'Înregistrează timp',
    total: 'Total',
    hours: 'ore',
    minutes: 'minute',
    date: 'Data',
    activity: 'Activitate',
    comment: 'Comentariu',
    noEntries: 'Nu există înregistrări de timp.',
    fields: {
      hours: 'Număr de ore',
      spentOn: 'Data',
      activity: 'Tip activitate',
      comment: 'Comentariu (opțional)',
    },
    errors: {
      saveFailed: 'Salvarea înregistrării de timp a eșuat.',
    },
    success: {
      saved: 'Timpul a fost înregistrat cu succes.',
    },
  },

  // Costuri
  costs: {
    title: 'Costuri',
    total: 'Costuri totale',
    labor: 'Costuri manoperă',
    material: 'Costuri materiale',
    hourlyRate: 'Rată orară',
  },

  // Căutare
  search: {
    // Textele descriau căutarea OpenProject peste `work_packages` (0 rânduri în
    // producție), înlocuită de căutarea în dosarele investițiilor. Cheile rămân
    // aceleași — se schimbă doar ce spun.
    placeholder: 'Caută în dosarele investițiilor…',
    noResults: 'Nu s-au găsit rezultate.',
    results: {
      projects: 'Proiecte',
      activities: 'Activități',
    },
    searching: 'Se caută...',
  },

  // Acțiuni comune
  common: {
    save: 'Salvează',
    cancel: 'Anulează',
    delete: 'Șterge',
    edit: 'Editează',
    add: 'Adaugă',
    close: 'Închide',
    confirm: 'Confirmă',
    back: 'Înapoi',
    next: 'Următorul',
    previous: 'Anterior',
    loading: 'Se încarcă...',
    saving: 'Se salvează...',
    error: 'Eroare',
    success: 'Succes',
    warning: 'Atenție',
    info: 'Informație',
    required: 'Obligatoriu',
    optional: 'Opțional',
    select: 'Selectează',
    selectOption: 'Selectează o opțiune',
    noData: 'Nu există date.',
    refresh: 'Reîmprospătează',
    viewAll: 'Vezi toate',
    viewMore: 'Vezi mai mult',
    showLess: 'Arată mai puțin',
    actions: 'Acțiuni',
    details: 'Detalii',
    created: 'Creat',
    updated: 'Actualizat',
    by: 'de',
    at: 'la',
    from: 'de la',
    to: 'până la',
    yes: 'Da',
    no: 'Nu',
    none: 'Niciunul',
    all: 'Toate',
    filter: 'Filtrează',
    clearFilters: 'Șterge filtrele',
    apply: 'Aplică',
    reset: 'Resetează',
  },

  // Mesaje de eroare
  errors: {
    general: 'A apărut o eroare. Încercați din nou.',
    notFound: 'Resursa nu a fost găsită.',
    unauthorized: 'Nu aveți permisiunea să efectuați această acțiune.',
    forbidden: 'Acces interzis.',
    validation: 'Verificați câmpurile introduse.',
    network: 'Eroare de conexiune. Verificați rețeaua.',
    server: 'Eroare de server. Încercați mai târziu.',
    timeout: 'Cererea a expirat. Încercați din nou.',
    loadFailed: 'Încărcarea datelor a eșuat.',
    saveFailed: 'Salvarea a eșuat.',
    deleteFailed: 'Ștergerea a eșuat.',
    createFailed: 'Crearea a eșuat.',
    updateFailed: 'Actualizarea a eșuat.',
  },

  // Mesaje de succes
  success: {
    saved: 'Salvat cu succes!',
    created: 'Creat cu succes!',
    updated: 'Actualizat cu succes!',
    deleted: 'Șters cu succes!',
    uploaded: 'Încărcat cu succes!',
  },

  // Tooltips și ajutor
  help: {
    subject: 'Introduceți un titlu scurt și descriptiv pentru această activitate.',
    description: 'Adăugați detalii despre ce trebuie făcut.',
    assignee: 'Persoana care execută această activitate.',
    dueDate: 'Data până la care activitatea trebuie finalizată.',
    estimatedTime: 'Timpul estimat pentru finalizarea activității (ex: 2h, 3d).',
    priority: 'Nivelul de urgență al acestei activități.',
    parent: 'Activitatea părinte (fază sau epic) sub care se încadrează aceasta.',
    version: 'Versiunea sau iterația în care este planificată activitatea.',
  },

  // Dosar Achiziție
  dosarInvestitie: {
    title: 'Dosar Achiziție',
    tabs: {
      dossier: 'Dosar Achiziție',
    },
    sections: {
      generalInfo: 'Informații generale',
      documents: 'Documente',
      financialData: 'Date financiare',
      timeline: 'Cronologie',
      status: 'Status dosar',
    },
    fields: {
      investmentName: 'Denumire achiziție',
      investmentValue: 'Valoare achiziție',
      financingSource: 'Sursa de finanțare',
      contractNumber: 'Număr contract',
      contractDate: 'Data contract',
      beneficiary: 'Beneficiar',
      implementationPeriod: 'Perioada de implementare',
      location: 'Locație',
      category: 'Categorie',
      description: 'Descriere achiziție',
    },
    actions: {
      addDocument: 'Adaugă document',
      generateReport: 'Generează raport',
      exportDossier: 'Exportă dosar',
      viewHistory: 'Vezi istoric',
    },
    statuses: {
      draft: 'Ciornă',
      submitted: 'Depus',
      inReview: 'În evaluare',
      approved: 'Aprobat',
      rejected: 'Respins',
      inImplementation: 'În implementare',
      completed: 'Finalizat',
    },
    messages: {
      noDocuments: 'Nu există documente în acest dosar.',
      loadError: 'Eroare la încărcarea dosarului de achiziție.',
      saveSuccess: 'Dosarul a fost salvat cu succes.',
      saveError: 'Eroare la salvarea dosarului.',
    },
  },

  // Formatare date
  dateFormats: {
    short: 'dd.MM.yyyy',
    long: 'dd MMMM yyyy',
    withTime: 'dd.MM.yyyy HH:mm',
    relative: {
      today: 'Astăzi',
      yesterday: 'Ieri',
      tomorrow: 'Mâine',
      daysAgo: 'acum {days} zile',
      inDays: 'în {days} zile',
    },
  },

  // Unități de timp
  timeUnits: {
    hours: 'ore',
    hour: 'oră',
    days: 'zile',
    day: 'zi',
    weeks: 'săptămâni',
    week: 'săptămână',
    months: 'luni',
    month: 'lună',
  },
};

// Funcție helper pentru a obține traducerea
export function t(key: string, params?: Record<string, string | number>): string {
  const keys = key.split('.');
  let value: unknown = translations;

  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = (value as Record<string, unknown>)[k];
    } else {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
  }

  if (typeof value !== 'string') {
    console.warn(`Translation key is not a string: ${key}`);
    return key;
  }

  if (params) {
    return value.replace(/\{(\w+)\}/g, (_, param) =>
      String(params[param] ?? `{${param}}`)
    );
  }

  return value;
}

// Mapare statusuri din OpenProject la română
export function translateStatus(status: string): string {
  const normalized = status.toLowerCase();
  const statusMap = translations.statuses as Record<string, string>;
  return statusMap[normalized] || status;
}

// Mapare priorități din OpenProject la română
export function translatePriority(priority: string): string {
  const normalized = priority.toLowerCase();
  const priorityMap = translations.priorities as Record<string, string>;
  return priorityMap[normalized] || priority;
}

// Mapare tipuri de work packages
export function translateWorkPackageType(type: string): string {
  const normalized = type.toLowerCase();
  const typeMap = translations.workPackages.types as Record<string, string>;
  return typeMap[normalized] || type;
}

// Mapare tipuri de relații
export function translateRelationType(relationType: string): string {
  const normalized = relationType.toLowerCase().replace(/\s+/g, '');
  const relationMap = translations.workPackages.relations.types as Record<string, string>;
  return relationMap[normalized] || relationType;
}

export default translations;
